var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgF1CarHighlighted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29438",
    "data-name": "Group 29438",
    transform: "translate(-154 -582.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(154 582.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_12_",
    "data-name": "svgexport-17 (12)",
    transform: "translate(168 596.467)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "astroligical_calendar",
    "data-name": "astroligical calendar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "F1_car",
    "data-name": "F1 car"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50498",
    "data-name": "Path 50498",
    d: "M31.352,1.071,30.33.057h0A.168.168,0,0,0,30.2,0H29.12a.17.17,0,1,0,0,.341h.469l.724.73Z",
    transform: "translate(-19.087 0)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50499",
    "data-name": "Path 50499",
    d: "M22.485,5.8l-5.416-1.81L15.958,2.884a1.359,1.359,0,0,0-1.231-.373l-3.417.683a.242.242,0,0,1-.068-.167V2.982a.244.244,0,0,1,.244-.244h.437a.341.341,0,0,0,.341-.341V2.057a.341.341,0,0,0-.341-.341H9.452a3.905,3.905,0,0,0-2.3.753,3.905,3.905,0,0,1-2.3.752H4.429a.341.341,0,0,0-.341.341v.88a.341.341,0,0,1-.341.341H3.407a.341.341,0,0,1-.341-.341V3.057a.341.341,0,0,0-.341-.341H.341A.341.341,0,0,0,0,3.057V4.572a.341.341,0,0,0,.188.3L4.016,6.79a.341.341,0,0,0,.152.036H15.275a.341.341,0,0,0,.108-.018l2.893-.964a.511.511,0,0,1,.245-.019l4.577.919c.211.043.408-.325.408-.54ZM12.508,3.76a.243.243,0,0,1-.175-.075l2.528-.506a.679.679,0,0,1,.616.186l.394.395Z",
    transform: "translate(0 -1.131)",
    fill: "#e53935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50500",
    "data-name": "Path 50500",
    d: "M15.985,12.952l-.56,1.12a.341.341,0,0,1-.3.188H4.429a.341.341,0,0,1-.341-.341v-.17H.341A.341.341,0,0,1,0,13.408v-.341a.341.341,0,0,1,.341-.341H4.088v-.17a.341.341,0,0,1,.341-.341h2a1.744,1.744,0,0,1,1.234.511,1.745,1.745,0,0,0,1.234.511h1.978a14.848,14.848,0,0,0,4.7-.762.341.341,0,0,1,.412.476Zm5.819.8h2.385a.341.341,0,0,0,.341-.341v-.341a.341.341,0,0,0-.341-.341H21.8a.341.341,0,0,0-.341.341v.341A.341.341,0,0,0,21.8,13.749Z",
    transform: "translate(0 -8.054)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_505",
    "data-name": "Ellipse 505",
    cx: 2.044,
    cy: 2.044,
    rx: 2.044,
    ry: 2.044,
    transform: "translate(1.022 2.629)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_506",
    "data-name": "Ellipse 506",
    cx: 1.444,
    cy: 1.444,
    rx: 1.444,
    ry: 1.444,
    transform: "translate(1.622 3.229)",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50501",
    "data-name": "Path 50501",
    d: "M5.876,12.206A1.614,1.614,0,1,1,7.49,10.592,1.614,1.614,0,0,1,5.876,12.206Zm0-2.888A1.273,1.273,0,1,0,7.15,10.592,1.273,1.273,0,0,0,5.876,9.319Z",
    transform: "translate(-2.81 -5.919)",
    fill: "#ff0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_507",
    "data-name": "Ellipse 507",
    cx: 0.513,
    cy: 0.513,
    rx: 0.513,
    ry: 0.513,
    transform: "translate(2.553 4.16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_508",
    "data-name": "Ellipse 508",
    cx: 2.044,
    cy: 2.044,
    rx: 2.044,
    ry: 2.044,
    transform: "translate(16.353 2.629)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_509",
    "data-name": "Ellipse 509",
    cx: 1.444,
    cy: 1.444,
    rx: 1.444,
    ry: 1.444,
    transform: "translate(16.953 3.229)",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50502",
    "data-name": "Path 50502",
    d: "M50.876,12.206a1.614,1.614,0,1,1,1.614-1.614A1.614,1.614,0,0,1,50.876,12.206Zm0-2.888a1.273,1.273,0,1,0,1.273,1.273A1.273,1.273,0,0,0,50.876,9.319Z",
    transform: "translate(-32.479 -5.919)",
    fill: "#ff0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_510",
    "data-name": "Ellipse 510",
    cx: 0.513,
    cy: 0.513,
    rx: 0.513,
    ry: 0.513,
    transform: "translate(17.884 4.16)",
    fill: "#fff"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF1CarHighlighted);
export default __webpack_public_path__ + "static/media/f1carHighlighted.873f04ac247a95f6ff83e180a2a08412.svg";
export { ForwardRef as ReactComponent };